import React from 'react';
import InputWrapper from './InputWrapper';

const DateTimeInput = ({ field, fieldId, value, onChange, label, isRequired, error }) => {
  const dateTimeValue = value ? (value.substring(0, 16)) : '';
  
  return (
    <InputWrapper field={field} label={label} isRequired={isRequired} error={error}>
      <div className="form-relative-container">
        <input
          type="datetime-local"
          className="profile-input form-input"
          value={dateTimeValue}
          onChange={e => onChange(fieldId, e.target.value)}
          disabled={field.readOnly || false}
        />
      </div>
    </InputWrapper>
  );
};

export default DateTimeInput;

